import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import iDEAlogo from "../../images/iDEA_small.png"
import iDEAvideoGame from "../../images/iDEA_VideoGames.jpg"
import FeedbackFaces from "../../images/FeedbackFaces_Red.jpg"



const IDEACaseStudy = () => {
  // const router = useNavigate();
  // const { iDEA } = useParams();

  const [pageTitle, setPageTitle] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] =
    useState("why/case-study/iDEA");

  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (iDEA)`,
      link: `/why/case-study/iDEA`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={"Client Case Study-Consultancy"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={iDEAlogo}
                title="Client Profile - SME Consultancy"
                objectFit="contain"
                subTitle="Management Consultancy with Multinational Clients"
                //example to link in text
                body={`UK-based iDEA are a workplace design specialist consultancy that identify and explain where change is needed, and what form it should take. 
                Whether it's an office block, or a recording studio, a warehouse, a teaching space, a hospital or an engineering workshop; iDEA have spent 
                the last 30 years perfecting the art of solving space.`}
              />
              <CustomizedAccordions
                title="iDEA Service Offer"
                body={`They are a close-knit team of thirty-something designers, thinkers, crafters and planners; they are not a huge faceless corporate 
                    workplace consultancy but an eclectic mix of creatives - a genuine family who relish the opportunity to share knowledge and expertise:
              <ul>
            <li><strong>Interiors</strong> - from BBC to RAF iDEA have planned, penned and perfected some of the UK's best workplace interiors </li>
            <li><strong>Graphics</strong> - iDEA's expertise in visual communication means we've got the knack of making complex, simple (and beautiful)  </li>
            <li><strong>Apps</strong> - iDEA have nurtured a talented team of developers who've created industry-leading applications </li>
            <li><strong>Strategy</strong> - iDEA vast combined knowledge of the workplace sector has proved us the go-to for estates briefing </li>
              </ul>
              `}
              />
              <CustomizedAccordions
                title="iDEA's Needs"
                body={`iDEA conduct regular analysis & forecasts of [   ]" approach</b>. 
                But to cross-check this domain-level methodology and ensure the analysis is coherent, iDEA commissioned MEF to provide [    ] projections using a <b>“top-down” macro/global scenario approach</b> - this also enables sensitivity analysis to be conducted ie 
                exploring  & quantifying <a title='unexpected outcomes significantly impacting business/economic outcomes'> shocks </a>from official macroeconomic projections that impact [     ].`}
              />

            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={iDEAvideoGame}
                title="Client Needs-Bespoke Model/Scenarios"
                objectFit="contain"
                subTitle={`Why iDEA use MEF services - iDEAmod bespoke model`}
                body={`<p>Following initial consultation & research, MEF constructed a specialist forecast/scenario model of Global Defence 
                Spending <b>iDEAmod</b> powered by macroeconomic/other outputs from MEF's <a href='/how/mGEM-global-macro' title="macro Global Econometric Model">mGEM</a> model. Global/national scenario analysis (ie imposing "shocks")
                can then be conducted on mGEM with outputs fed into iDEAmod to derive domain-level, fully-consistent risk analysis 
                of national Defence Spending. The likely range of uncertainty in this key metric for iDEA can then be identified & quantified for their own
                consultancy offer to clients. iDEAmod sensitivity analysis - crucial for iDEA clients' strategic planning - is thus "globally-consistent" 
                and thus more robust.</p>`}
              />
              <CustomizedAccordions
                title="Bespoke Model-Building Process: iDEAmod"
                body={`This global model of [Student Numbers] in all major GLobal regions  (eg US, China, Russia, France, Germany, Turkey etc..) was assembled by MEF economists who
                have built/maintained the MEF suite of (structural) economic models. This latter knowledge allows them to propose the best structure for <i>client-owned</i> satelitte models - that focus on
                the client's core domain area (eg for iDEA, National Defence procurement) - and the particular mGEM driver variables that will power such <a title="a model that does not feedback to the driver model"> recursive </a> client satellite models. 
                MEF sourced required data and then estimated a (structural) model of National Defence Spending <b>iDEAmod</b> typically driven by national factors (fiscal capacity, 
                demographic/social spending) and geopolitical factors (Defence Spending by non-friendly nations). <b>iDEAmod</b> covers all the major Defence Spending nations in 
                order to ensure that geo-political drivers are fully-specified; in essence, it captures the dynamics of any global arms race to ensure fully-consistent Defence Spending scenarios.
                Once operational, forecast scenario analysis can then be run on <b>iDEAmod</b> in a fully-coherent way given (global) macro drivers from mGEM scenario exercises.<br><br>
                `}
              />
              <CustomizedAccordions
                title="iDEAmod Scenario Analysis; using mGEM Scenario Drivers "
                body="Once deployed, iDEA commission MEF to “stress-test” official (ie OBR, OECD, IMF) Budget projections with plausible global macro scenarios to capture & quantify 
                domain-level uncertainty around central projections; these are then fed-through to <b>iDEAmod</b> to quantify related uncertainties in possible Defence Spending outturns to 2040.
                iDEA  typically conduct such mGEM-iDEAmod scenario update exercises with MEF after each major fiscal event in the UK; they can then pre-empt any potential deviations from the 
                official baseline forecast and its ramifications for Global/UK Defence Spending to 2040."
              />
              {/* Download not working ! + need .PDF icon
              <a href="./public/downloads/MEF_iDEA_CaseStudy.pdf">    <button>Case Study .PDF</button> </a>  */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackFaces}
                title="Client Feedback"
                objectFit="contain"
                subTitle={`On MEF services & how iDEAmod scenarios are used - iDEA`}
                body={`<i>"[ TBC ]"</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's modelling and/or scenario services may augment your risk analysis, please email us
                at: <b style="color:#00a0a0" > bespoke@mef-uk.com </b> `}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default IDEACaseStudy;
// IDEACaseStudy.getInitialProps = async ({ whyData }: any) => {
//   return whyData;
// };
